import { render, staticRenderFns } from "./CompletePickUp.vue?vue&type=template&id=6bf65641&scoped=true"
import script from "./CompletePickUp.vue?vue&type=script&lang=js"
export * from "./CompletePickUp.vue?vue&type=script&lang=js"
import style0 from "./CompletePickUp.vue?vue&type=style&index=0&id=6bf65641&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bf65641",
  null
  
)

export default component.exports